<div class="printReceipt" id="receipt">
	<div class="col-sm-12">
		<div class="row logo-row">
			<div class="col-sm-6 logo-col">
				<img alt="Rapidship" class="img-responsive receipt-logo"
					 src="{{companyLogo ? companyLogo : 'assets/images/alt-logo.png'}}">
			</div>
			<div class="col-sm-6 header-col">
				<h1 class="header">
					<span *ngIf="shipmentType === 'OnDemand'">
						{{'receiptView.trackingId' | translate}}: {{receiptDetails?.order?.id}}
					</span>
					<span *ngIf="shipmentType === 'Routed'">
						{{'receiptView.stopIdLabel' | translate}}: {{receiptDetails?.order?.stopId}}
					</span>
				</h1>
			</div>
		</div>
		<div class="row contentSection col-sm-12  customer-info">		
			<div class="col-sm-12">
				<div class="col-sm-3 label">Customer ID :</div>
				<div class="col-sm-9">{{receiptDetails?.order?.custId}}</div>
			</div>
			<div class="col-sm-12">
				<div class="col-sm-3 label">Customer Name :</div>
				<div class="col-sm-9">{{receiptDetails?.order?.custName}}</div>
			</div>
		</div>
		<div class="row contentSection col-sm-12">
			<div *ngIf="shipmentType === 'OnDemand' && !hideOriginAddress" class="col-sm-6 address-col">
				<strong>{{receiptDetails?.captions?.originCaption || ('receiptView.originLabel' | translate)}}</strong>
				<div>{{receiptDetails?.order?.origin?.name}}</div>
				<div>{{receiptDetails?.order?.origin?.address1}}
				  <span *ngIf="receiptDetails?.order?.origin?.address2">, {{receiptDetails?.order?.origin?.address2}}</span>
				</div>
				<div>{{receiptDetails?.order?.origin?.city}}, {{receiptDetails?.order?.origin?.state}} {{receiptDetails?.order?.origin?.zip}}</div>
			  
				<!-- New normalized contact/phone/comment block -->
				<div class="address-block">
				  <div class="line labels">
					<span class="label">Contact</span>
					<span class="label">Phone</span>
				  </div>
				  <div class="line values">
					<span>{{receiptDetails?.order?.origin?.contact}}</span>
					<span>{{receiptDetails?.order?.origin?.phone}}</span>
				  </div>
				  <div class="line labels">
					<span class="label">Comment</span>
				  </div>
				  <div class="line values">
					<span>{{receiptDetails?.order?.origin?.comment}}</span>
				  </div>
				</div>
			</div>							
			<div class="col-sm-6 address-col" *ngIf="!hideDestinationAddress">
				<strong *ngIf="shipmentType === 'OnDemand'">
				  {{receiptDetails?.captions?.destCaption || ('receiptView.destinationLabel' | translate)}}
				</strong>
				<strong *ngIf="shipmentType === 'Routed'">
				  {{'receiptView.locationLabel' | translate}}
				</strong>
			  
				<div>{{receiptDetails?.order?.destination?.name}}</div>
				<div>
				  {{receiptDetails?.order?.destination?.address1}}
				  <span *ngIf="receiptDetails?.order?.destination?.address2">
					, {{receiptDetails?.order?.destination?.address2}}
				  </span>
				</div>
				<div>
				  {{receiptDetails?.order?.destination?.city}},
				  {{receiptDetails?.order?.destination?.state}}
				  {{receiptDetails?.order?.destination?.zip}}
				</div>
			  
				<!-- New normalized contact/phone/comment block -->
				<div class="address-block">
				  <div class="line labels">
					<span class="label">Contact</span>
					<span class="label">Phone</span>
				  </div>
				  <div class="line values">
					<span>{{receiptDetails?.order?.destination?.contact}}</span>
					<span>{{receiptDetails?.order?.destination?.phone}}</span>
				  </div>
				  <div class="line labels">
					<span class="label">Comment</span>
				  </div>
				  <div class="line values">
					<span>{{receiptDetails?.order?.destination?.comment}}</span>
				  </div>
				</div>
			</div>			  
			<div *ngIf="shipmentType === 'Routed'" class="col-sm-6">
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.stopTypeLabel' | translate}}
					</div>
					<div class="col-sm-8">
						{{receiptDetails?.order?.stopType?.name}}
					</div>
				</div>
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.parcelsLabel' | translate}}
					</div>
					<div class="col-sm-8">
						{{receiptDetails?.order?.parcels?.length}}
					</div>
				</div>
			</div>
		</div>
		<div class="row contentSection col-sm-12">
			<div class="col-sm-6 details-col">
				<div *ngIf="shipmentType === 'OnDemand'" class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.orderedByLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.caller}}</div>
				</div>
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{selectedCustomer?.captions?.referenceCaption ?
						selectedCustomer?.captions?.referenceCaption : ('receiptView.referenceLabel' | translate)}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.ref1}}</div>
				</div>
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{selectedCustomer?.captions?.referenceCaption2 ?
						selectedCustomer?.captions?.referenceCaption2 : ('receiptView.reference2Label' | translate)}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.ref2}}</div>
				</div>
				<div *ngIf="shipmentType === 'OnDemand'" class="col-sm-12">
					<div class="col-sm-4 label">
						{{selectedCustomer?.captions?.serviceTypeCaption ?
						selectedCustomer?.captions?.serviceTypeCaption : ('receiptView.serviceTypeLabel' | translate)}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.serviceTypeDescription}}</div>
				</div>
				<div *ngIf="shipmentType === 'OnDemand'" class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.orderTypeLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.orderTypeDescription}}</div>
				</div>
				<div class="col-sm-12">
					<div *ngIf="shipmentType === 'OnDemand'" class="col-sm-4 label">
						{{'receiptView.orderedLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.ordered?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.ordered?.formattedTime}} {{receiptDetails?.order?.timestamps?.ordered?.timeZone}}
					</div>
				</div>
			</div>
			<div class="col-sm-6 details-col">
				<div *ngIf="receiptDetails?.order?.pieces" class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.piecesLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.pieces}}</div>
				</div>
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.weightLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.weight}}</div>
				</div>
				<div *ngIf="!user?.inetUser?.hideRates && !hideRating && shipmentType === 'OnDemand'"
					 class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.totalChargesLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.charges | currency:'USD':'symbol':'1.2-2'}}</div>
				</div>
				<div *ngIf="!hideRating && shipmentType === 'OnDemand'" class="col-sm-12">
					<div class="col-sm-4 label">
						{{selectedCustomer?.captions?.billingGroupCaption ? selectedCustomer?.captions?.billingGroupCaption : 'Billing Group / Cost Center'}}
					</div>
					<div class="col-sm-8">
						{{receiptDetails?.order?.customerBillingGroup}}
					</div>
				</div>
				<div *ngIf="shipmentType === 'OnDemand'" class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.dispatchedLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.dispatched?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.dispatched?.formattedTime}} {{receiptDetails?.order?.timestamps?.dispatched?.timeZone}}
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="shipmentType === 'OnDemand'" class="row contentSection col-sm-12">
			<div class="col-sm-6 timing-col">
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.readyLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.readyTimeFrom?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.readyTimeFrom?.formattedTime}} {{receiptDetails?.order?.timestamps?.readyTimeFrom?.timeZone}}
					</div>
				</div>
				<div *ngIf="!user.hideDeliverBy" class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.dueLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.dueTimeTo?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.dueTimeTo?.formattedTime}} {{receiptDetails?.order?.timestamps?.dueTimeTo?.timeZone}}
					</div>
				</div>
			</div>
			<div class="col-sm-6 timing-col">
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.pickedUpLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.pickedUp?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.pickedUp?.formattedTime}} {{receiptDetails?.order?.timestamps?.pickedUp?.timeZone}}
					</div>
				</div>
				<div class="col-sm-12">
					<div class="col-sm-4 label">
						{{'receiptView.deliveredLabel' | translate}}
					</div>
					<div class="col-sm-8">{{receiptDetails?.order?.timestamps?.delivered?.formattedDate}}
						{{receiptDetails?.order?.timestamps?.delivered?.formattedTime}} {{receiptDetails?.order?.timestamps?.delivered?.timeZone}}
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!hideStatusCodes" class="row contentSection col-sm-12">
			<strong>{{'receiptView.statusCodesLabel' | translate}}:</strong>
			<table class="full-width">
				<thead>
				<tr>
					<th>{{'receiptView.codeLabel' | translate}}</th>
					<th>{{'receiptView.commentLabel' | translate}}</th>
					<th>{{'receiptView.timeLabel' | translate}}</th>
				</tr>
				</thead>
				<tbody *ngIf="receiptDetails?.order">
				<tr *ngFor="let s of receiptDetails?.order.statusCodes">
					<td class="align-center">{{s?.statusCodeId}}</td>
					<td class="align-center">{{s?.comment}}</td>
					<td class="align-center">{{s?.createdWhen?.formattedDate}} {{s?.createdWhen?.formattedTime}} {{s?.createdWhen?.timeZone}}</td>
				</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="!hideParcelInfo" class="row contentSection col-sm-12">
			<strong>{{'receiptView.parcelInfoLabel' | translate}}:</strong>
			<table class="full-width">
				<thead>
				<tr>
					<th>{{'parcelsView.parcelIdColumnHeader' | translate}}</th>
					<th>{{'parcelsView.barcodeColumnHeader' | translate}}</th>
					<th>{{'parcelsView.piecesColumnHeader' | translate}}</th>
					<th>{{'parcelsView.weightColumnHeader' | translate}}</th>
					<th>{{'parcelsView.parcelTypeColumnHeader' | translate}}</th>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let p of receiptDetails?.order?.parcels; let i = index"
							  class="parcel-information">
					<tr>
						<td class="align-center" data-title="Parcel ID">{{p?.id}}</td>
						<td class="align-center" data-title="Barcode">{{p.reference ? p.reference : p.barcode}}</td>
						<td class="align-center" data-title="Pieces">{{p?.pieces}}</td>
						<td class="align-center" data-title="Weight">{{p?.weight}}</td>
						<!--TODO: This is a OR because of BE inconsistencies, if they fix it so all endpoints return the type as object we can remove the or and typeDescription-->
						<td class="align-center" data-title="Parcel Type">
							{{p?.typeDescription || p?.type?.description}}
						</td>
					</tr>
					<tr class="light">
						<td class="remove-p-all" colspan="6">
							<div class="with-borders parcel-details">
								<span *ngIf="p?.assignments.length > 0" class="assignments-container">
									<span *ngFor="let a of p?.assignments" class="assignment-wrap">
										<span class="assignment-type">
											{{a?.type}}
										</span>
										<span *ngIf="!a.scannedWhen">Not scanned</span>
										<span *ngIf="a.scannedWhen" class="assignment-scanned-when">
											{{a?.scannedWhen?.formattedDate}} {{a?.scannedWhen?.formattedTime}} {{a?.scannedWhen?.timeZone}}
										</span>
										<span *ngIf="a.exceptionDescription || a.exceptionDesc"
											  class="assignment-exception">
											{{a.exceptionDescription ? a.exceptionDescription : a.exceptionDesc}}
										</span>
										<span *ngIf="a.scanComment || a.comment" class="assignment-comment">
											{{a.scanComment ? a.scanComment : a.comment}}
										</span>
										<div class="parcel-items-wrap">
											<span *ngFor="let i of a.items" class="parcel-item-row item-details">
												<span class="parcel-item-description">
													{{i.parcelItem.description}}
												</span>
												<span class="align-right">{{i.quantity}}</span>
											</span>
											<span class="parcel-item-row item-totals">
												<span class="parcel-item-total">
													Total Parcel Items 
												</span>
												<span class="align-right">{{a.itemTotal}}</span>
											</span>
											
										</div>
									</span>
								</span>
							</div>
						</td>
					</tr>
				</ng-container>
				</tbody>
			</table>
		</div>
		<div class="row col-sm-12 pod-section">
			<strong>{{'receiptView.proofOfDeliveryLabel' | translate}}:</strong>
			<div class="row col-sm-12">
				<div class="col-sm-6 pod-detail">
					<div class="col-sm-12">
						<div class="col-sm-4 label">
							{{'receiptView.nameLabel' | translate}}:
						</div>
						<div class="col-sm-8">{{receiptDetails?.order?.proofOfDelivery?.pod}}</div>
					</div>
					<div class="col-sm-12">
						<div class="col-sm-4 label">
							{{'receiptView.commentLabel' | translate}}:
						</div>
						<div class="col-sm-8">{{receiptDetails?.order?.proofOfDelivery?.podComments}}</div>
					</div>
					<div class="col-sm-12">
						<div class="col-sm-4 label">
							{{'receiptView.dateTimeLabel' | translate}}:
						</div>
						<div class="col-sm-8">
					<span *ngIf="shipmentType === 'OnDemand'">
						{{receiptDetails?.order?.timestamps?.delivered?.formattedDate}} {{receiptDetails?.order?.timestamps?.delivered?.formattedTime}} {{receiptDetails?.order?.timestamps?.delivered?.timeZone}}
					</span>
							<span *ngIf="shipmentType === 'Routed'">
						{{receiptDetails?.order?.timestamps?.completed?.formattedDate}} {{receiptDetails?.order?.timestamps?.completed?.formattedTime}} {{receiptDetails?.order?.timestamps?.completed?.timeZone}}
					</span>
						</div>
					</div>
				</div>
				<div *ngIf="!hideSignature" class="col-sm-6">
					<img
							*ngIf="receiptDetails?.order?.proofOfDelivery?.base64EncodedSignature"
							[src]="receiptDetails.order.proofOfDelivery.base64EncodedSignature"
							class="img-signature"/>
				</div>
			</div>
		</div>
	</div>
</div>
